import React, {FC, Key, ReactNode} from 'react'

import {
  ChannelSettingSequenceRowSpan,
  getChannelSettingSequenceSlotClass,
} from 'src/utils/channelSettingSequenceLayout'

type ChannelSettingSequenceSlotProps = {
  rank?: number
  rowSpan?: ChannelSettingSequenceRowSpan
  slotModifierClass?: string
  hidden?: boolean
  children: ReactNode
}

export type ChannelSettingSequenceWrapOptions = {
  rowSpan?: ChannelSettingSequenceRowSpan
  slotModifierClass?: string
  hidden?: boolean
}

/** Flex order on the legacy col-* slot; inner width/margin classes are stripped. */
const ChannelSettingSequenceSlot: FC<ChannelSettingSequenceSlotProps> = ({
  rank,
  rowSpan = 'half',
  slotModifierClass,
  hidden = false,
  children,
}) => (
  <div
    className={getChannelSettingSequenceSlotClass(rowSpan, slotModifierClass)}
    style={hidden ? {display: 'none'} : rank == null ? undefined : {order: rank}}
  >
    {children}
  </div>
)

export const withChannelSettingSequence = (
  rank: number | undefined,
  key: Key,
  node: ReactNode,
  options?: ChannelSettingSequenceWrapOptions
) => {
  if (node == null || node === false) {
    return null
  }

  return (
    <ChannelSettingSequenceSlot
      key={key}
      rank={rank}
      rowSpan={options?.rowSpan ?? 'half'}
      slotModifierClass={options?.slotModifierClass}
      hidden={options?.hidden}
    >
      {node}
    </ChannelSettingSequenceSlot>
  )
}

export default ChannelSettingSequenceSlot
